import { Box, Card, CardContent, Skeleton, Stack } from '@mui/material'

// Loading placeholder for the View Application page, shown by PageContainer while
// resources load. Mirrors ViewCreditApplicationBody's shape: applicant card →
// ApplicationProgress (stage content + progress list) → Documents + Notes row.
// Breakpoints match the real body (side-by-side at `lg`, stacked below).
const ViewApplicationSkeleton = () => (
  <Stack spacing={2}>
    <Card>
      <CardContent>
        <Stack spacing={2}>
          <Skeleton variant="text" width={220} height={32} />
          <Stack direction={{ xs: 'column', lg: 'row' }} spacing={3}>
            <Skeleton variant="rounded" height={140} sx={{ flex: 1 }} />
            <Skeleton variant="rounded" height={140} sx={{ flex: 1 }} />
          </Stack>
        </Stack>
      </CardContent>
    </Card>
    {/* ApplicationProgress: stage-content card + progress-list card (420px aside). */}
    <Stack direction={{ xs: 'column', lg: 'row' }} spacing={2} alignItems="stretch">
      <Box sx={{ flex: 1 }}>
        <Skeleton variant="rounded" height={440} />
      </Box>
      <Box sx={{ width: { xs: '100%', lg: 420 }, flexShrink: 0 }}>
        <Skeleton variant="rounded" height={440} />
      </Box>
    </Stack>
    {/* Documents + Notes row (420px aside — matches the ApplicationProgress row). */}
    <Stack direction={{ xs: 'column', lg: 'row' }} spacing={2} alignItems="stretch">
      <Box sx={{ flex: 1 }}>
        <Skeleton variant="rounded" height={320} />
      </Box>
      <Box sx={{ width: { xs: '100%', lg: 420 }, flexShrink: 0 }}>
        <Skeleton variant="rounded" height={320} />
      </Box>
    </Stack>
  </Stack>
)

export default ViewApplicationSkeleton
